import scrollIntoViewIfNeeded from "scroll-into-view-if-needed";
import {
  addDefaultContainerPlugins,
  addDefaultContainerPluginsReact,
  parsePluginContainers,
  parsePluginContainersReact,
} from "./plugins_inside_plugins";
import { ID_PREFIX_BOX } from "./constants";
import { CANVAS_STAGE_INSETS } from "./layout_constants";
let html2json = require("html2json").html2json;
import i18n from "i18next";
import { contentT } from "./content_language";

// px → em with the same rounding the browser's CSSOM serializer applies
// (~6 significant digits, e.g. 18px → "1.28571"). CKEditor's font-size combo
// recognises a span ONLY by exact string match between the span's style value
// and its configured size entry — full-precision floats (1.2857142857142858em)
// never survive a DOM round-trip, so the combo silently fell back to the
// default "14" for every size. All em producers below share this helper.
export function pxToEm(px) {
  return parseFloat((px / 14).toFixed(5));
}

export function fontString() {
  // let canvas = document.getElementById('canvas');
  let fontArray = [];
  for (let index = 6; index < 72; index++) {
    fontArray.push(index);
  }
  // let fonts_length = fontArray.map((number) => number + '/' + (Math.round(number / (window.innerWidth * 0.01) * 100) / 100) + 'vw');
  let fonts_length = fontArray.map((number) => number + "/" + pxToEm(number) + "em");
  let fontsString = fonts_length.join(";");
  return fontsString;
}

export function normalizeFontSizes(html) {
  if (!html || typeof html !== "string") {
    return html || "";
  }

  return html.replace(/font-size:\s*([\d.]+)(px|em)/gi, (match, size, unit) => {
    let pxValue = parseFloat(size);

    if (unit.toLowerCase() === "em") {
      pxValue = pxValue * 14;
    }
    const rounded = Math.round(pxValue);
    return `font-size:${pxToEm(rounded)}em`;
  });
}

export function changeFontBase(width = 900) {
  const DEFAULT_FONT_BASE = 14;
  const DEFAULT_WIDTH_BASE = 1100;
  let calculatedFontSize = (DEFAULT_FONT_BASE * parseFloat(width)) / DEFAULT_WIDTH_BASE;
  window.FONT_BASE = calculatedFontSize;
  // $('.boxStyle').css("font-size", calculatedFontSize + "px");
  return calculatedFontSize;
}
export function aspectRatio(
  ratioparam,
  idEl = "airlayer",
  idParent = "canvas",
  customSize = 0,
  fromVisor = false
) {
  // change ratio to the global ratio store in the app
  let ratio = ratioparam;
  let canvas = document.getElementById(idParent);
  let parent = document.getElementById(idEl);

  let height = canvas ? canvas.style.height : 0;
  let width = canvas ? canvas.style.width : 0;
  let marginTop = canvas ? canvas.style.marginTop : 0;
  let marginBottom = canvas ? canvas.style.marginBottom : 0;

  // Visor letterboxes to the full container; the editor reserves stage insets.
  const ins = fromVisor ? { top: 0, bottom: 0, left: 0, right: 0 } : CANVAS_STAGE_INSETS;

  /* this is to avoid get values from react flow when using event listeners that do not exist in react
   * get the values from window.object */
  if (canvas) {
    const availW = canvas.offsetWidth - ins.left - ins.right;
    const availH = canvas.offsetHeight - ins.top - ins.bottom;
    if (customSize === 0) {
      if (window.canvasRatio === undefined) {
        window.canvasRatio = ratio; // https://stackoverflow.com/questions/19014250/reactjs-rerender-on-browser-resize
      } else {
        ratio = window.canvasRatio;
      }
      // Contain-fit and center the slide inside the available region.
      let w = availW;
      let h = availH;
      if (availW > ratio * availH) {
        w = ratio * availH;
      } else {
        h = availW / ratio;
      }
      width = w + "px";
      height = h + "px";
      marginTop = parent ? ins.top + (availH - h) / 2 + "px" : "0px";
    } else if (fromVisor) {
      let customRatio = customSize.width / customSize.height;

      if (customRatio > ratio) {
        width = canvas.offsetWidth + "px";
        height = canvas.offsetWidth / customRatio + "px";
      } else {
        height = canvas.offsetHeight + "px";
        width = canvas.offsetHeight * customRatio + "px";
      }
    } else {
      height = customSize.height + "px";
      width = customSize.width + "px";
      marginTop = ins.top + (availH - customSize.height) / 2 - 1;
      marginTop = marginTop > 0 ? marginTop : 0;
      marginTop += "px";
    }
  }
  return { width, height, marginTop, marginBottom };
}

export function shuffle(array) {
  let tmp,
    current,
    top = array.length;
  if (top) {
    while (--top) {
      current = Math.floor(Math.random() * (top + 1));
      tmp = array[current];
      array[current] = array[top];
      array[top] = tmp;
    }
  }
  return array;
}

export function toggleFullScreen(element) {
  if (!element) {
    element = document.documentElement;
  }

  if (isFullScreenOn()) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  } else if (
    !element.fullscreenElement && // alternative standard method
    !element.mozFullScreenElement &&
    !element.webkitFullscreenElement &&
    !element.msFullscreenElement
  ) {
    // current working methods
    if (element.requestFullscreen) {
      element.requestFullscreen();
      document.body.requestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
      document.body.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
      document.body.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      document.body.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    }
  }
}

export function isFullScreenOn() {
  return (
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
  );
}

export function fullScreenListener(callback, set) {
  if (set) {
    document.addEventListener("webkitfullscreenchange", callback);
    document.addEventListener("mozfullscreenchange", callback);
    document.addEventListener("fullscreenchange", callback);
    document.addEventListener("MSFullscreenChange", callback);
  } else {
    document.removeEventListener("webkitfullscreenchange", callback);
    document.removeEventListener("mozfullscreenchange", callback);
    document.removeEventListener("fullscreenchange", callback);
    document.removeEventListener("MSFullscreenChange", callback);
  }
}

/**
 * Calculate if a click was released on top of any element of a kind
 * Example: Check if plugin was dropped on top of another plugin. Check in which sortable it was dropped, etc.
 * @param releaseClick Element where the click was released
 * @param name Prefix of the className of the parent we are looking for
 * @returns {*}
 */
export function releaseClick(releaseClickEl, name, isComplex) {
  let isComp = isComplex;
  if (releaseClickEl && releaseClickEl.getAttribute) {
    // Get element that has been clicked
    let release = releaseClickEl.getAttribute("id") || "noid";
    let counter = 12;
    // Check recursively the parent of the element clicked to check if any of them has the name that we are looking for
    while (release && release.indexOf(name) === -1 && counter > 0 && releaseClickEl.parentNode) {
      releaseClickEl = releaseClickEl.parentNode;
      if (releaseClickEl && releaseClickEl.getAttribute) {
        release = releaseClickEl.getAttribute("id") || "noid";
        if (release.indexOf(name) !== -1 && releaseClickEl.parentNode && isComp) {
          isComp = false;
          releaseClickEl = releaseClickEl.parentNode;
          release = releaseClickEl.getAttribute("id") || "noid";
        }
      } else {
        counter = 0;
        break;
      }
      counter--;
    }
    if (counter > 0 && release && release.indexOf(name) !== -1) {
      let partialID = release.split(name);
      if (partialID && partialID.length > 0) {
        return partialID[1];
      }
    }
  }
  return undefined;
}

export function instanceExists(name) {
  let isCV = $("#containedCanvas").css("display") !== "none";
  let alreadyOne = false;
  let query = (isCV ? "#containedCanvas" : "#canvas") + " .wholebox";
  $(query).each((ind, el) => {
    if (el.getAttribute("name") === name) {
      alreadyOne = true;
      return;
    }
  });

  return alreadyOne;
}

export function scrollElement(node, options) {
  let cfg = options || { duration: 300, centerIfNeeded: true, easing: "easeInOut" };
  if (node) {
    let isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(!window.safari || (typeof safari !== "undefined" && safari.pushNotification));

    if (!isSafari) {
      scrollIntoViewIfNeeded(node, cfg);
    }
  }
}

export function findBox(id) {
  return document.getElementById("box-" + id);
}

export function letterFromNumber(ind) {
  if (!isNaN(ind)) {
    const abc = "abcdefghijklmnopqrstuvwxyz";
    return abc[ind % abc.length];
  }
  return ind;
}

export function createBox(ids, name, slide, addBox, boxes, styleCustom = {}) {
  let apiPlugin = IdealStudio.Plugins.get(name);
  if (!apiPlugin) {
    return;
  }

  const apiConfig = apiPlugin.getConfig();

  if (apiConfig && apiConfig.fullScreenOverlay) {
    const pageId = ids.page != null && ids.page !== 0 ? ids.page : ids.parent;
    ids = { ...ids, parent: pageId, container: 0, position: { x: 0, y: 0, type: "absolute" } };
    delete ids.index;
    delete ids.col;
    delete ids.row;
    slide = true;
  }
  let { initialParams, template, config, toolbar, state } = apiPlugin.getInitialParams({
    ...ids,
    slide,
  });
  // Remember which Components ("Bileşenler") section the item came from, so
  // "Replace File" can reopen the right section regardless of the asset URL.
  if (ids.componentType && state) state.componentType = ids.componentType;
  // Video Director: "Replace File" on this box reopens the project it came from.
  if (ids.videoProjectId && state) state.videoProjectId = ids.videoProjectId;
  // Hareketli Görsel GIF/WebP: the document the image was rendered from, so the
  // pill's "AI ile düzenle" can edit it and re-render the loop.
  if (ids.motionSource && state) state.motionSource = ids.motionSource;
  let styles = {};
  try {
    if (toolbar.main && toolbar.main.accordions && toolbar.main.accordions.style) {
      Object.keys(toolbar.main.accordions.style.buttons).map((e) => {
        styles[e] = toolbar.main.accordions.style.buttons[e].value;
      });
    }
    styles = { ...styles, ...styleCustom };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  let newBoxes = [];
  let newPluginState = {};
  if (state.__pluginContainerIds) {
    if (config.flavor !== "react") {
      addDefaultContainerPlugins(ids, template, boxes, newBoxes);
      parsePluginContainers(template, newPluginState);
    } else {
      addDefaultContainerPluginsReact(ids, template, boxes, newBoxes);
      parsePluginContainersReact(template, newPluginState, {}, boxes, ids.id);
    }
    state.__pluginContainerIds = newPluginState;
  }

  addBox(
    { ...ids, config: apiPlugin.getConfig() },
    true,
    slide,
    template,
    styles,
    state,
    undefined,
    initialParams
  );

  let basePrefix = ID_PREFIX_BOX + Date.now();

  newBoxes.map((box, ind) => {
    box.ids.id = basePrefix + "_" + ind;
    if (box.ids && ids.exercises) {
      if (box.ids.container === "sc-Question") {
        box.ids.initialState = { __text: ids.exercises.question || box.ids.initialState };
      }

      let ans = box.ids.container.match(/sc-Answer(\d+)/);
      if (ans && ans.length > 1 && !isNaN(ans[1])) {
        box.ids.initialState = { __text: ids.exercises.answers[ans[1]] || box.ids.initialState };
      }
      if (box.ids.container === "sc-Feedback") {
        box.ids.initialState = { __text: ids.exercises.feedback || box.ids.initialState };
      }
    }
    createBox(box.ids, box.name, false, addBox, boxes);
  });
  setTimeout(() => {
    let boxCreated = findBox(ids.id);
    scrollElement(boxCreated);
  }, 40);
}

export function blurCKEditor(id, callback) {
  if (CKEDITOR.instances[id]) {
    CKEDITOR.instances[id].focusManager.blur(true);
    let data = CKEDITOR.instances[id].getData();

    // Remove HTML comments before saving to state
    data = data.replace(/<!--[\s\S]*?-->/g, "");

    if (data.length === 0) {
      data = "<p>" + i18n.t("text_here") + "</p>";
      CKEDITOR.instances[id].setData(data);
    }
    // No actual edit since the editor opened (CKEDitorComponent snapshots
    // getData right after each setData) → close WITHOUT text, so the caller
    // toggles the editor off but writes nothing. Committing here anyway would
    // store normalize/CKEditor-rewritten markup — an open+close with zero
    // typing visibly changed font sizes and dirtied undo.
    if (
      CKEDITOR.instances[id].__aideaOpenData !== undefined &&
      data === CKEDITOR.instances[id].__aideaOpenData
    ) {
      callback(undefined, undefined);
    } else {
      callback(encodeURI(data), html2json(encodeURI(data)));
    }
    let airlayer = document.getElementsByClassName("airlayer");
    if (airlayer && airlayer.length > 0 && airlayer.forEach) {
      airlayer.forEach((al) => al.focus());
    } else {
      document.body.focus();
    }
  }
}

export function getRandomColor() {
  return `#${Math.floor(Math.random() * 0x1000000)
    .toString(16)
    .padStart(6, 0)}`;
}

function rgbtoHex(n) {
  n = parseInt(n, 10);
  if (isNaN(n)) {
    return "00";
  }
  n = Math.max(0, Math.min(n, 255));
  let num = "0123456789ABCDEF".charAt((n - (n % 16)) / 16) + "0123456789ABCDEF".charAt(n % 16);
  return num;
}

export function toColor(rgba) {
  let regex = /rgba\((\d+),(\d+),(\d+),(.+)\)/;
  let oldColor = regex.exec(rgba);
  if (oldColor && oldColor.length > 0) {
    let newColor = "#" + rgbtoHex(oldColor[1]) + rgbtoHex(oldColor[2]) + rgbtoHex(oldColor[3]);
    return { newColor: newColor, alpha: oldColor[4] * 100 };
  }
  return { newColor: rgba, alpha: 100 };
}
export function translateLicense(license) {
  let dict = {
    public: "Public Domain",
    "cc-by": "CreativeCommons BY",
    "cc-by-sa": "CreativeCommons BY-SA",
    "cc-by-nd": "CreativeCommons BY-ND",
    "cc-by-nc": "CreativeCommons BY-NC",
    "cc-by-nc-sa": "CreativeCommons BY-NC-SA",
    "cc-by-nc-nd": "CreativeCommons BY-NC-ND",
  };

  return dict[license];
}

export function setRgbaAlpha(color, alpha) {
  if (color) {
    if (color.charAt(0) === "#") {
      let cutHex = color.substring(1, 7);
      let r = parseInt(cutHex.substring(0, 2), 16);
      let g = parseInt(cutHex.substring(2, 4), 16);
      let b = parseInt(cutHex.substring(4, 6), 16);
      color = "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
    }
    return color.replace(/[\d\.]+\)$/g, alpha.toString() + ")");
  }
  return "rgba(234, 183, 0, 0.25)";
}

export function convertSecondsToHMS(time) {
  // eslint-disable-next-line no-bitwise
  let hrs = ~~(time / 3600);
  // eslint-disable-next-line no-bitwise
  let mins = ~~((time % 3600) / 60);
  let secs = Math.round(time % 60);

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = "";

  if (secs === 60) {
    secs = 0;
    mins += 1;
  }

  if (mins === 60) {
    hrs += 1;
  }

  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }

  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;

  return ret;
}

export function convertHMStoSeconds(time) {
  let a = time.split(":");
  let finalValue;
  if (a.length === 2) {
    finalValue = +a[0] * 60 + +a[1];
  } else {
    finalValue = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
  }
  return finalValue;
}

export function pad(str) {
  str = str.toString();
  return str.length < 2 ? "0" + str : str;
}

export function safeDecodeURI(str) {
  if (!str || typeof str !== "string") {
    return str === 0 ? "0" : str || "";
  }

  if (!str.includes("%")) {
    return str;
  }

  // Whitelisted single-byte ASCII entities that should always be decoded
  const asciiDecodeMap = {
    "%09": "\t", // tab
    "%0A": "\n", // newline
    "%0D": "\r", // carriage return
    "%20": " ", // space
    "%21": "!", // exclamation
    "%22": '"', // double quote
    "%23": "#", // hash
    "%24": "$", // dollar
    "%26": "&", // ampersand
    "%27": "'", // single quote
    "%28": "(", // open paren
    "%29": ")", // close paren
    "%2B": "+", // plus
    "%2C": ",", // comma
    "%2F": "/", // slash
    "%3A": ":", // colon
    "%3B": ";", // semicolon
    "%3C": "<", // less than
    "%3D": "=", // equals
    "%3E": ">", // greater than
    "%3F": "?", // question mark
    "%40": "@", // at sign
    "%5B": "[", // open bracket
    "%5D": "]", // close bracket
    "%5E": "^", // caret
    "%60": "`", // backtick
    "%7B": "{", // open brace
    "%7C": "|", // pipe
    "%7D": "}", // close brace
    "%7E": "~", // tilde
  };

  let result = str;

  // Smart %25 decode: Only decode double-encoded percent signs
  // %25XX (where XX is hex) -> %XX (double-encoded, decode it)
  // %25X followed by non-hex -> %X (single digit percent like %2,5)
  // %25 followed by non-hex at start -> keep as %25 (literal "25%")

  // First: %25 + two hex digits
  result = result.replace(/%25([0-9A-Fa-f]{2})/g, "%$1");
  // Second: %25 + single hex digit followed by non-hex (like %252,5 -> %2,5)
  result = result.replace(/%25([0-9A-Fa-f])([^0-9A-Fa-f])/g, "%$1$2");
  // Third: %25 + single hex at end of string
  result = result.replace(/%25([0-9A-Fa-f])$/g, "%$1");

  // Step 1: Decode whitelisted ASCII entities
  for (const [encoded, decoded] of Object.entries(asciiDecodeMap)) {
    const regex = new RegExp(encoded, "gi");
    result = result.replace(regex, decoded);
  }

  // Step 3: Decode valid UTF-8 multi-byte sequences

  // 2-byte UTF-8: %C2-%DF followed by %80-%BF
  result = result.replace(/%([CD][0-9A-Fa-f])%([89AB][0-9A-Fa-f])/g, (match) => {
    try {
      return decodeURIComponent(match);
    } catch (e) {
      return match;
    }
  });

  // 3-byte UTF-8: %E0-%EF followed by two %80-%BF
  result = result.replace(
    /%([Ee][0-9A-Fa-f])%([89AB][0-9A-Fa-f])%([89AB][0-9A-Fa-f])/g,
    (match) => {
      try {
        return decodeURIComponent(match);
      } catch (e) {
        return match;
      }
    }
  );

  // 4-byte UTF-8: %F0-%F4 followed by three %80-%BF
  result = result.replace(
    /%([Ff][0-4])%([89AB][0-9A-Fa-f])%([89AB][0-9A-Fa-f])%([89AB][0-9A-Fa-f])/g,
    (match) => {
      try {
        return decodeURIComponent(match);
      } catch (e) {
        return match;
      }
    }
  );

  return result;
}

// Maps a text-format key (BasicText/RichText pill's box-level state property)
// to the CSS property it controls, plus how to turn the dispatched value into
// that property's CSS value. Used by forceHtmlCssProperty below — shared by
// both the single-box pill (EditorShortcuts.jsx) and the multi-select bar
// (EditorApp.jsx's applyMultiTextValue) so a font/style change behaves
// identically regardless of how many boxes are selected.
export const TEXT_FORMAT_CSS_PROP = {
  bold: ["font-weight", (v) => (v ? "bold" : "normal")],
  italic: ["font-style", (v) => (v ? "italic" : "normal")],
  underline: ["text-decoration", (v) => (v ? "underline" : "none")],
  textAlign: ["text-align", (v) => v],
  textFontFamily: ["font-family", (v) => v],
  textFontSize: ["font-size", (v) => v + "px"],
  textColor: ["color", (v) => v],
  highlightColor: ["background-color", (v) => v],
};

// Forces one CSS property to one value on every element in an HTML fragment,
// overriding any inline style already set on that element (e.g. a per-span
// color/font-family CKEditor applied earlier from its own native toolbar, or
// a PREVIOUS box-level format change forced in by this same function). Plain
// CSS gives an element's own inline style precedence over whatever a
// wrapper-level box-state property would otherwise cascade down, so a format
// change was silently invisible on already-styled RichText content — this
// rewrites the content itself instead of relying on inheritance. `__text` is
// stored URI-encoded (see blurCKEditor below, which writes it via
// encodeURI) — decode before parsing as HTML and re-encode before returning,
// or DOMParser just sees literal "%3Cp%3E…" text with no elements to restyle
// and silently returns the input unchanged.
// Drops <p> / </p> tags, with or without attributes — for renderers that split
// the HTML into plain text pieces (fill-in-the-blank). A font or format applied
// to the box styles every <p>, so a literal "<p>" match is not enough.
export function stripParagraphTags(html) {
  return String(html || "")
    .replace(/<p(\s[^>]*)?>/g, "")
    .replace(/<\/p>/g, "");
}

export function forceHtmlCssProperty(html, cssProp, cssValue) {
  const doc = new DOMParser().parseFromString(`<div>${safeDecodeURI(html)}</div>`, "text/html");
  const root = doc.body.firstChild;
  [root, ...root.querySelectorAll("*")].forEach((el) => el.style.setProperty(cssProp, cssValue));
  return encodeURI(root.innerHTML);
}

// Box-level on/off toggles (the pill's B/I/U). Forcing "normal"/"none" on
// every element when a toggle is turned back OFF erased whatever the content
// had BEFORE the toggle (a bold <strong> word, a per-span weight) — "bold then
// un-bold" left the text flatter than it started. So the forward toggle
// snapshots each element's prior inline value (`data-pre-<prop>` =
// "forced|original") and the reverse toggle restores it instead of forcing the
// opposite value. Without a matching snapshot (legacy content, or the value
// changed since through another path) it falls back to forceHtmlCssProperty.
export const TEXT_TOGGLE_KEYS = ["bold", "italic", "underline"];

export function toggleHtmlCssProperty(html, cssProp, cssValue) {
  const doc = new DOMParser().parseFromString(`<div>${safeDecodeURI(html)}</div>`, "text/html");
  const root = doc.body.firstChild;
  const attr = "data-pre-" + cssProp;
  const els = Array.from(root.querySelectorAll("*"));
  const snapshotOf = (el) => {
    const raw = el.getAttribute(attr);
    if (raw === null) return null;
    const cut = raw.indexOf("|");
    const forced = raw.slice(0, cut);
    // Still valid only while the element carries exactly what we forced.
    if (cut < 0 || el.style.getPropertyValue(cssProp) !== forced) return null;
    return { forced, original: raw.slice(cut + 1) };
  };
  const restoring = els.some((el) => {
    const snap = snapshotOf(el);
    return snap && snap.forced !== cssValue;
  });
  if (restoring) {
    els.forEach((el) => {
      const snap = snapshotOf(el);
      if (snap) {
        if (snap.original) el.style.setProperty(cssProp, snap.original);
        else el.style.removeProperty(cssProp);
      } else if (el.style.getPropertyValue(cssProp) !== "" && el.getAttribute(attr) === null) {
        // Element created after the forward toggle (typing split a span and
        // copied the forced style) — let it inherit the restored ancestor.
        el.style.removeProperty(cssProp);
      }
      el.removeAttribute(attr);
    });
  } else {
    els.forEach((el) => {
      el.setAttribute(attr, cssValue + "|" + el.style.getPropertyValue(cssProp));
      el.style.setProperty(cssProp, cssValue);
    });
  }
  els.forEach((el) => {
    if (el.getAttribute("style") === "") el.removeAttribute("style");
  });
  return encodeURI(root.innerHTML);
}

// em → px at the app's 14px base (see pxToEm).
function cssFontSizeToPx(value) {
  const match = /^([\d.]+)(px|em)$/i.exec(String(value).trim());
  if (!match) return null;
  const size = parseFloat(match[1]);
  if (!Number.isFinite(size)) return null;
  return Math.round(match[2].toLowerCase() === "em" ? size * 14 : size);
}

// Formatting the stored HTML actually renders with — the shared fallback when
// box state has no value (pill, CKEditor, copy-style). First explicit value per
// property wins; <strong>/<em>/<u> count too.
export function deriveTextFormatFromHtml(html) {
  const out = {
    bold: null,
    italic: null,
    underline: null,
    textAlign: null,
    textFontFamily: null,
    textFontSize: null,
    textColor: null,
    highlightColor: null,
  };
  if (!html || typeof DOMParser === "undefined") {
    return { ...out, bold: !!out.bold, italic: !!out.italic, underline: !!out.underline };
  }
  const doc = new DOMParser().parseFromString(`<div>${safeDecodeURI(html)}</div>`, "text/html");
  const root = doc.body.firstChild;
  if (!root) {
    return { ...out, bold: false, italic: false, underline: false };
  }
  [root, ...root.querySelectorAll("*")].forEach((el) => {
    const st = el.style || {};
    if (out.textFontSize === null && st.fontSize) out.textFontSize = cssFontSizeToPx(st.fontSize);
    if (out.textFontFamily === null && st.fontFamily) {
      out.textFontFamily = st.fontFamily.replace(/["']/g, "");
    }
    if (out.textColor === null && st.color) out.textColor = st.color;
    if (out.highlightColor === null && st.backgroundColor) out.highlightColor = st.backgroundColor;
    if (out.textAlign === null && st.textAlign) out.textAlign = st.textAlign;
    if (out.bold === null && st.fontWeight) {
      out.bold = st.fontWeight === "bold" || Number(st.fontWeight) >= 600;
    }
    if (out.italic === null && st.fontStyle) out.italic = st.fontStyle === "italic";
    if (out.underline === null && st.textDecoration) {
      out.underline = st.textDecoration.indexOf("underline") !== -1;
    }
    const tag = el.tagName;
    if (out.bold === null && (tag === "STRONG" || tag === "B")) out.bold = true;
    if (out.italic === null && (tag === "EM" || tag === "I")) out.italic = true;
    if (out.underline === null && tag === "U") out.underline = true;
  });
  return { ...out, bold: !!out.bold, italic: !!out.italic, underline: !!out.underline };
}

// Memoized on the html string; the pill calls this on every render.
let _derivedHtml = null;
let _derivedValue = null;
export function deriveTextFormatCached(html) {
  if (html !== _derivedHtml) {
    _derivedHtml = html;
    _derivedValue = deriveTextFormatFromHtml(html);
  }
  return _derivedValue;
}

// Removes one CSS property from every element of an HTML fragment. The
// counterpart of forceHtmlCssProperty for properties that must live ONLY on
// the box wrapper: font-size is em-based, so a value forced onto content
// elements multiplies with the wrapper's own em value (1.29em × 1.29em) and
// text renders ~29% bigger than the pill claims. Clearing content-level
// font-size leaves the wrapper as the single owner — which also out-ranks
// nothing, because absence of a child value inherits the wrapper's.
export function stripHtmlCssProperty(html, cssProp) {
  const doc = new DOMParser().parseFromString(`<div>${safeDecodeURI(html)}</div>`, "text/html");
  const root = doc.body.firstChild;
  [root, ...root.querySelectorAll("*")].forEach((el) => el.style.removeProperty(cssProp));
  [root, ...root.querySelectorAll("*")].forEach((el) => {
    if (el.getAttribute && el.getAttribute("style") === "") el.removeAttribute("style");
  });
  // Unwrap spans left with no attributes at all — otherwise every strip cycle
  // (set size → edit → derive → strip) deposits another layer of bare <span>s.
  root.querySelectorAll("span").forEach((el) => {
    if (el.attributes.length === 0) {
      while (el.firstChild) el.parentNode.insertBefore(el.firstChild, el);
      el.remove();
    }
  });
  return encodeURI(root.innerHTML);
}

// Prepares __text for the full CKEditor: converts box-level bold/italic/
// underline (the pill's whole-box toggles — stored as state flags AND forced
// per-element css by forceHtmlCssProperty above) into real <strong>/<em>/<u>
// markup, stripping the forced css. CKEditor's B/I/U commands only add/remove
// those tags — they never touch an inline `font-weight:bold` on a <p> — so
// without this pass a pill-applied bold could not be removed per selection in
// the editor: the css kept winning and the toggle looked dead. Returns null
// when nothing needed converting (caller skips the state write). The caller
// must clear the box-level flags alongside storing the returned __text, or
// the wrapper css re-bolds everything.
export function materializeTextDecorations(html, flags = {}) {
  if (!html) return null;
  const specs = [
    { flag: "bold", prop: "font-weight", on: "bold", tag: "strong", tags: ["strong", "b"] },
    { flag: "italic", prop: "font-style", on: "italic", tag: "em", tags: ["em", "i"] },
    { flag: "underline", prop: "text-decoration", on: "underline", tag: "u", tags: ["u"] },
  ];
  const doc = new DOMParser().parseFromString(`<div>${safeDecodeURI(html)}</div>`, "text/html");
  const root = doc.body.firstChild;
  // Drop a now-meaningless tag, keeping its children (and any other inline
  // styles/attributes it carried, via a <span>).
  const unwrapTag = (el) => {
    const keeps = Array.from(el.attributes || []).filter((a) => a.value.trim() !== "");
    if (keeps.length) {
      const span = doc.createElement("span");
      keeps.forEach((a) => span.setAttribute(a.name, a.value));
      while (el.firstChild) span.appendChild(el.firstChild);
      el.replaceWith(span);
    } else {
      while (el.firstChild) el.parentNode.insertBefore(el.firstChild, el);
      el.remove();
    }
  };
  let changed = false;
  for (const s of specs) {
    const all = [root, ...root.querySelectorAll("*")];
    const cssOn = all.some((el) => (el.style.getPropertyValue(s.prop) || "").includes(s.on));
    const hasCss = all.some((el) => el.style.getPropertyValue(s.prop) !== "");
    const on = !!flags[s.flag] || cssOn;
    // No box-level involvement (no flag, no forced css): partial tag-based
    // formatting from a previous CKEditor session — leave untouched.
    if (!on && !hasCss) continue;
    changed = true;
    all.forEach((el) => el.style.removeProperty(s.prop));
    if (on) {
      // Wrap each top-level block's content (or the bare root's) in the tag.
      const blocks = root.children.length ? Array.from(root.children) : [root];
      blocks.forEach((b) => {
        if (b.children.length === 1 && b.firstElementChild.tagName.toLowerCase() === s.tag) return;
        const w = doc.createElement(s.tag);
        while (b.firstChild) w.appendChild(b.firstChild);
        b.appendChild(w);
      });
    } else {
      // The pill explicitly turned this OFF: forceHtmlCssProperty muted every
      // element with "none"/"normal" css but left old semantic tags in place.
      // The muting css is stripped above, so the tags must go too — otherwise
      // a previously-underlined word RESURFACES the moment the editor opens.
      root.querySelectorAll(s.tags.join(",")).forEach(unwrapTag);
    }
  }
  if (!changed && !flags.bold && !flags.italic && !flags.underline) return null;
  [root, ...root.querySelectorAll("*")].forEach((el) => {
    if (el.getAttribute && el.getAttribute("style") === "") el.removeAttribute("style");
  });
  return encodeURI(root.innerHTML);
}

// Prepares the DECODED html fed into CKEditor (setData): when the box carries
// a box-level textFontSize and the content itself has none, wraps each block's
// content in a span with that size (px → em, base 14). Inside the editor the
// wrapper's own em mirror is suppressed (EditorBox skips it while
// showTextEditor) — otherwise a size picked in CKEditor nested UNDER the
// wrapper's em and rendered compounded (~29% oversized) until close. This is
// editor-session-only sugar: it changes the data in the editor, never the
// stored __text — the close-time derivation decides ownership as usual.
export function injectBoxFontSize(decodedHtml, textFontSize) {
  const px = parseInt(textFontSize, 10);
  if (!decodedHtml || !(px > 0)) return decodedHtml;
  const doc = new DOMParser().parseFromString(`<div>${decodedHtml}</div>`, "text/html");
  const root = doc.body.firstChild;
  const hasFs = [root, ...root.querySelectorAll("*")].some(
    (el) => el.style && el.style.getPropertyValue("font-size") !== ""
  );
  if (hasFs) return decodedHtml;
  const em = pxToEm(px) + "em";
  const blocks = root.children.length ? Array.from(root.children) : [root];
  blocks.forEach((b) => {
    const w = doc.createElement("span");
    w.style.setProperty("font-size", em);
    while (b.firstChild) w.appendChild(b.firstChild);
    b.appendChild(w);
  });
  return root.innerHTML;
}

// Inverse of materializeTextDecorations, run when the full CKEditor commits:
// reads the edited HTML and derives the box-level format state the pill
// displays, so the two toolbars stay in sync. Toggles follow an ALL-text rule
// (bold only if every text node is bold — "hepsi bold değilse bold kalkmalı");
// value props (font family/size/color) come back as: a string when every text
// node explicitly carries the same value, null when values are explicit but
// mixed (caller clears the box-level prop — content owns the styling), and
// undefined when some text has no explicit value (caller keeps the current
// box-level prop — the wrapper is what styles that text). Returns null for
// empty/whitespace-only content.
export function deriveTextFormatState(html) {
  if (!html) return null;
  const doc = new DOMParser().parseFromString(`<div>${safeDecodeURI(html)}</div>`, "text/html");
  const root = doc.body.firstChild;
  const walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const texts = [];
  while (walker.nextNode()) {
    if (walker.currentNode.textContent.trim() !== "") texts.push(walker.currentNode);
  }
  if (!texts.length) return null;
  // Effective value of `prop` for a text node: nearest ancestor (up to root)
  // with an inline value, or "TAG" when a semantic tag is hit first. On the
  // SAME element the inline css wins over the tag's default rendering —
  // <u style="text-decoration:none"> is NOT underlined (that's exactly what
  // the pill's forced "off" css produces), so css is checked before the tag.
  const effective = (node, prop, tags) => {
    for (let el = node.parentElement; el; el = el.parentElement) {
      const v = el.style ? el.style.getPropertyValue(prop) : "";
      if (v) return v;
      if (tags && tags.includes(el.tagName.toLowerCase())) return "TAG";
      if (el === root) break;
    }
    return "";
  };
  const isBold = (v) => v === "TAG" || v === "bold" || v === "bolder" || parseInt(v, 10) >= 600;
  const uniform = (prop) => {
    let val;
    for (const t of texts) {
      const v = effective(t, prop, null);
      if (!v) return undefined;
      if (val === undefined) val = v;
      else if (val !== v) return null;
    }
    return val;
  };
  return {
    bold: texts.every((t) => isBold(effective(t, "font-weight", ["strong", "b"]))),
    italic: texts.every((t) => {
      const v = effective(t, "font-style", ["em", "i"]);
      return v === "TAG" || v === "italic";
    }),
    underline: texts.every((t) => {
      const v = effective(t, "text-decoration", ["u"]);
      return v === "TAG" || v.includes("underline");
    }),
    fontFamily: uniform("font-family"),
    fontSize: uniform("font-size"),
    color: uniform("color"),
  };
}

// Resolves the DOM node that actually renders a box's content — the plain
// view-mode wrapper (`.boxStyle`) when it exists, otherwise the CKEditor
// edit-mode contentEditable div (which shares the box's own id, unprefixed).
// Both live inside the `box-<id>` wrapper EditorBox.jsx renders.
export function getBoxContentEl(id) {
  const scope = document.getElementById(`box-${id}`);
  return scope && (scope.querySelector(".boxStyle") || document.getElementById(id));
}

// Live-previews a CSS property on a box's rendered content — its own DOM node
// AND every descendant — so a per-run/per-span style a PREVIOUS format commit
// already forced in (see forceHtmlCssProperty) can't out-rank a value that's
// only being hovered, not yet committed (an inline style on a descendant
// always wins over one on an ancestor, regardless of which was set more
// recently). `snapshot` is whatever this function last returned for the same
// element — pass it back in on every call so `value: null` (mouse/focus
// leaves the row) can restore each element's EXACT prior value. Naively
// resetting every element to the box's committed default on revert would
// erase intentional per-run overrides a RichText author made via CKEditor's
// own toolbar; snapshotting preserves them.
export function previewCssOnBox(el, cssProp, value, snapshot) {
  if (!el) return snapshot;
  if (value != null) {
    const entries = snapshot || [el, ...el.querySelectorAll("*")].map((t) => [t, t.style[cssProp]]);
    entries.forEach(([t]) => {
      t.style[cssProp] = value;
    });
    return entries;
  }
  if (snapshot) {
    snapshot.forEach(([t, prev]) => {
      t.style[cssProp] = prev;
    });
  }
  return null;
}

/**
 * Robust backward compatibility check for "letters/numbers" radio state.
 * Prevents language change bugs by dynamically checking if the value matches "ShowNumbers" in any supported language.
 */
export function isShowNumbersCondition(stateLetters) {
  if (stateLetters === "numbers") return true;
  if (!stateLetters || typeof stateLetters !== "string") return false;

  const langs = ["tr", "en", "es"];
  return langs.some(
    (lng) =>
      stateLetters === i18n.t("MultipleChoice.ShowNumbers", { lng }) ||
      stateLetters === i18n.t("MultipleAnswer.ShowNumbers", { lng })
  );
}

// Default labels follow the training language.
export function getButtonText(savedText, defaultTranslationKey) {
  if (!savedText) return contentT(defaultTranslationKey);
  return savedText;
}

// ponytail: plugins live deep inside the canvas with no route to VisorApp's
// setState, so they signal the shared visor toast with a custom event.
// VisorApp listens and renders it inside <VisorChrome> (recorder-leak guard).
export function showVisorToast(body, title) {
  if (typeof window === "undefined" || typeof window.CustomEvent !== "function") return;
  window.dispatchEvent(new CustomEvent("aidea:visorToast", { detail: { body, title } }));
}

export function updateDefaultTextsToContentLanguage(
  pluginToolbarsById,
  dispatch,
  updatePluginToolbar
) {
  Object.keys(pluginToolbarsById).forEach((id) => {
    const toolbar = pluginToolbarsById[id];
    if (!toolbar || !toolbar.state || !toolbar.state.__i18nKey) return;
    const key = toolbar.state.__i18nKey;
    const prefix = toolbar.state.__prefix !== undefined ? toolbar.state.__prefix : "<p>";
    const suffix = toolbar.state.__suffix !== undefined ? toolbar.state.__suffix : "</p>";
    const newText = prefix + contentT(key) + suffix;
    if (toolbar.state.__text !== newText) {
      dispatch(updatePluginToolbar(id, "main", "state", "__text", newText));
    }
  });
}
